export default function extractData<T extends { data: unknown }>(
  response: T | undefined | null,
): T['data'] {
  return response?.data
}
